import React from 'react';
import "../Styles/Banner.css"
import video from '../Assets/Videos/video.mp4'
import Navbar from './Navbar';

const Banner = () => {
    return (
        <div className='banner'>
            <video src={video} autoPlay loop muted />
            <div className='content'>
                <Navbar />

                <div>
                    <div className="hero min-h-screen ">
                        <div className="hero-content text-center">
                            <div className="max-w-md">
                                <h1 className="text-3xl font-bold">WEB DEVELOPMENT COMPANY</h1>
                                <p className="py-6">Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a id nisi.</p>
                                <button className="btn btn-primary">Get Started</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Banner;